import { z } from "zod";
import { appointmentRecurrenceSchema } from "./appointment-recurrence.js";
import { AGENDA_TIMEZONE, agendaToday } from "./appointment-recurrence.js";
const dateSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .refine((value) => {
    const [year, month, day] = value.split("-").map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
}, "Data inválida.");
const timeSchema = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/);
export const appointmentStatusSchema = z.enum(["SCHEDULED", "IN_PROGRESS", "COMPLETED", "CANCELLED"]);
export const appointmentServiceTypeSchema = z.enum(["REMOTE", "ONSITE"]);
export const appointmentTeamSchema = z.enum(["INTERNAL", "EXTERNAL", "HARDWARE", "INFRA", "HEALTH"]);
export const appointmentDateQuerySchema = dateSchema;
export const appointmentAttentionScopeSchema = z.enum(["mine", "visible"]).default("mine");
export const appointmentAttentionModeSchema = z.enum(["all", "alerts"]).default("all");
/** Minutes until the end of an appointment in the agenda's civil timezone. */
export function appointmentMinutesUntilDue(appointment, now = new Date()) {
    const today = agendaToday(now);
    const time = new Intl.DateTimeFormat("en-GB", {
        timeZone: AGENDA_TIMEZONE,
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23"
    }).format(now);
    const [hour, minute] = time.split(":").map(Number);
    const dayMinutes = (date) => Date.parse(`${date}T00:00:00Z`) / 60_000;
    return dayMinutes(appointment.date) + appointment.startMinute + appointment.durationMinutes
        - dayMinutes(today) - hour * 60 - minute;
}
export const createAppointmentSchema = z.object({
    recurrence: appointmentRecurrenceSchema.optional(),
    title: z.string().trim().min(3).max(200),
    description: z.string().trim().max(10_000).default(""),
    companyId: z.string().trim().min(1).max(160).nullable().optional(),
    assignedUserId: z.string().trim().min(1).max(160),
    date: dateSchema,
    startTime: timeSchema,
    durationMinutes: z.number().int().min(15).max(480),
    serviceType: appointmentServiceTypeSchema.default("REMOTE"),
    team: appointmentTeamSchema.default("INTERNAL"),
    priority: z.boolean().default(false)
}).refine((input) => {
    const [hour, minute] = input.startTime.split(":").map(Number);
    return hour * 60 + minute + input.durationMinutes <= 1440;
}, { message: "O agendamento precisa terminar no mesmo dia.", path: ["durationMinutes"] })
    .refine(input => input.team !== "EXTERNAL" || input.serviceType === "ONSITE", { message: "Atendimentos da equipe Externo devem ser presenciais.", path: ["serviceType"] });
export const updateAppointmentSchema = z.object({
    scope: z.enum(["ONE", "FUTURE", "ALL"]).optional(),
    expectedSeriesVersion: z.number().int().min(0).optional(),
    recurrence: appointmentRecurrenceSchema.optional(),
    expectedVersion: z.number().int().min(0),
    title: z.string().trim().min(3).max(200).optional(),
    description: z.string().trim().max(10_000).optional(),
    companyId: z.string().trim().min(1).max(160).nullable().optional(),
    assignedUserId: z.string().trim().min(1).max(160).optional(),
    date: dateSchema.optional(),
    startTime: timeSchema.optional(),
    durationMinutes: z.number().int().min(15).max(480).optional(),
    serviceType: appointmentServiceTypeSchema.optional(),
    team: appointmentTeamSchema.optional(),
    priority: z.boolean().optional(),
    status: appointmentStatusSchema.exclude(["CANCELLED"]).optional()
}).refine((input) => Object.keys(input).some((key) => !["expectedVersion", "expectedSeriesVersion", "scope"].includes(key)), "Informe ao menos uma alteração.");
export const cancelAppointmentSchema = z.object({ expectedVersion: z.number().int().min(0) });
